import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const SeniorityEnum = z.enum([
  "intern",
  "junior",
  "mid",
  "senior",
  "staff",
  "principal",
  "lead",
  "manager",
  "director",
]);

export const GenerateJdSchema = z.object({
  role: z.string().min(1).max(200),
  seniority: SeniorityEnum.default("mid"),
  industry: z.string().min(1).max(200).optional(),
  focusAreas: z.array(z.string().min(1).max(100)).max(5).optional(),
});

export class GenerateJdDto extends createZodDto(GenerateJdSchema) {}
